// extracted by mini-css-extract-plugin
export var columnList = "_av-0";